import { render } from "./UsersList.vue?vue&type=template&id=500b98c4&scoped=true"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"

import "./UsersList.vue?vue&type=style&index=0&id=500b98c4&lang=scss&scoped=true"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500b98c4"]])

export default __exports__